export default __webpack_public_path__ + "static/media/block-icon.254a8e73.svg";